import { ActionType } from "../common/enum/action";
import { ElementTypeEnum } from "../common/enum/elementType";
import { InputMode } from "../common/enum/inputMode";
import { Validate } from "../common/enum/validate";
import { Defines } from "../common/types/defines";
import { EventType } from "../common/types/event";
import { ChatItemDefines } from "../component/chatItem/IChatItem";
import { ButtonLabelDefines, ButtonDefines } from "../element/button/IButton";
import { CheckDefines } from "../element/check/ICheck";
import { FetchDefines } from "../element/fetch/IFetch";
import { GroupDefines } from "../element/group/IGroup";
import { RadioItemDefines, RadioDefines } from "../element/radio/IRadio";
import { OptionItemElement, SelectDefines } from "../element/select/ISelect";
import { TextDefines } from "../element/text/IText";
import { TextareaDefines } from "../element/textarea/ITextarea";
import { EventDefines, ActionDefines, EventProps } from "../interface/IEvent";

const chatformInfo = { id: "" };
function createChatformComponent() {
  function __item(
    sender: string,
    name: string,
    contents: Defines[],
    event: EventDefines
  ): ChatItemDefines {
    return {
      sender, name,
      contents, event
    };
  }
  return {
    say: function(sender = "bot", text: string){
      return { sender, contents: [{ text }] };
    },
    me: function(
      name: string,
      contents: Defines[],
      event?: EventDefines
    ): ChatItemDefines {
      return { ...__item("user", name, contents, event), progress: true, stop: true };
    },
    you: function(
      name: string,
      contents: Defines[],
      event?: EventDefines
    ): ChatItemDefines {
      return { ...__item("bot", name, contents, event), progress: false, stop: false };
    },
    info: function(
      name: string,
      contents: Defines[],
      event?: EventDefines
    ): ChatItemDefines {
      return { ...__item("system", name, contents, event), progress: false, stop: true };
    }
  }
}
function createChatformElement() {
  return {
    fetch: function(
      name: string,
      label: string,
      url: string,
      params: string[],
      def: Defines
    ): FetchDefines {
      return {
        type: ElementTypeEnum.FETCH,
        name, label, url, params,
        displayLabel: true,
        def
      };
    },
    group: function(
      name: string,
      label: string,
      required: boolean,
      contents: Defines[],
      validate: string[],
      classList: string[],
      enableChildInvalid: boolean,
      hiddenErrorPrefixLabel: boolean
    ): GroupDefines {
      return {
        type: ElementTypeEnum.GROUP,
        name,
        label,
        required,
        contents,
        validate,
        displayLabel: true,
        classList,
        enableChildInvalid,
        hiddenErrorPrefixLabel
      };
    },
    check: function(name: string, label: string): CheckDefines {
      return { type: ElementTypeEnum.CHECK, name, label };
    },
    text: function(
      name: string,
      label: string,
      required: boolean = true,
      inputType: InputMode = InputMode.TEXT,
      validate: Validate[] = [],
      displayLabel = true,
      hideInvalidMessage = false
    ): TextDefines {
      var option = inputType ? {
        type: inputType,
        style: "split"
      } : undefined;
      return {
        type: ElementTypeEnum.TEXT,
        name,
        label,
        placeholder: label,
        required,
        displayLabel,
        validate,
        option,
        hideInvalidMessage
      };
    },
    select: function(
      name: string,
      label: string,
      required = true,
      defaultOptionItem: OptionItemElement = undefined,
      options: OptionItemElement[],
      displayLabel = true
    ): SelectDefines {
      return {
        type: ElementTypeEnum.SELECT,
        name,
        label,
        required,
        defaultOptionItem,
        options,
        displayLabel
      }
    },
    radio: function(
      name: string,
      label: string,
      required = true,
      items: RadioItemDefines[]
    ): RadioDefines {
      return {
        type: ElementTypeEnum.RADIO,
        name,
        label,
        required,
        items
      };
    },
    textarea: function(
      name: string,
      label: string,
      defaultValue: string,
      readonly: boolean,
      rows: number,
    ): TextareaDefines {
      return {
        type: ElementTypeEnum.TEXTAREA,
        name, label, defaultValue,
        readonly, rows
      }
    },
    button: function(
      label: ButtonLabelDefines|string,
      event: EventDefines
    ): ButtonDefines {
      return {
        type: ElementTypeEnum.BUTTON,
        label, event
      }
    }
  }
}
function createEventCallbacks() {
  return {
    builder: function(
      args: {
        eventName: EventType,
        actions: (ActionType|Function)[]
      }[]
    ) {
      return args.reduce((p, c) => {
        const _actions = c.actions.reduce<ActionDefines>((_p, _c) => {
          if (typeof _c === "string") {
            if (!_p.actions) _p.actions = [];
            _p.actions.push(_c);
          } else if (typeof _c === "function") {
            if (!_p.callbacks) _p.callbacks = [];
            _p.callbacks.push(_c);
          }
          return _p;
        }, { actions: [], callbacks: [], ...(p[c.eventName] || {})});
        p[c.eventName] = {
          ..._actions,
          data: null
        };
        return p;
      }, {} as EventProps);
    }
  }
}

export const initializeUtil = {
  chatformInfo, createChatformComponent,
  createChatformElement, createEventCallbacks
};